import { environmentHttpClient as httpClient } from "client/Api/httpClient";

export enum CustomerType {
	Commercial = 1,
	Education = 2,
	Nonprofit = 3
}

export enum EmployeeSize {
	_1_10 = 1,
	_11_50 = 2,
	_51_200 = 3,
	_201_500 = 4,
	_501_1000 = 5,
	_1001_5000 = 6,
	_5001_10000 = 7,
	MoreThan10000 = 8
}

export enum Industry {
	Agriculture = 1,
	ChemicalManufacturing = 2,
	Construction = 3,
	Defense = 4,
	Education = 5,
	Energy = 6,
	EntertainmentAndMedia = 7,
	FinancialServices = 8,
	FoodAndBeverage = 9,
	Government = 10,
	Healthcare = 11,
	Hospitality = 12,
	InformationTechnology = 13,
	Manufacturing = 14,
	Other = 15,
	Software = 16,
	Telecom = 17,
	Transport = 18,
	Creative = 19,
	Consulting = 20,
	Legal = 21,
	Retail = 22
}

export enum SubIndustry {
	Other = 1,

	Ministries = 2,
	Provinces = 3,
	Municipalities = 4,
	GovernmentUtilities = 5,

	PrimaryEducation = 6,
	SecondaryEducation = 7,
	HigherEducation = 8,

	ElderCare = 9,
	DisabilityCare = 10,
	RehabilitationCare = 11,
	YouthCare = 12,
	MentalHealthcare = 13,
	Childcare = 14,
	Hospital = 15,
	Physio = 16,
	GeneralPractitioners = 17,

	Accounting = 18,
	CommercialBanking = 19,
	Insurance = 20
}

export enum BillingEnvironmentType {
	Default = 0,
	Demo = 1,
	NotForResale = 2
}

export type CustomerInfoModel = {
	name: string | null;
	referenceNumber: string | null;
	customerType: CustomerType | null;
	industry: Industry | null;
	subIndustries: readonly SubIndustry[] | null;
	otherIndustry: string | null;
	employeeSize: EmployeeSize | null;
	environmentType: BillingEnvironmentType;
};

export type CustomerInfoSaveModel = {
	name: string;
	referenceNumber: string | null;
	customerType: CustomerType | null;
	industry: Industry | null;
	subIndustries: readonly SubIndustry[] | null;
	otherIndustry: string | null;
	employeeSize: EmployeeSize | null;
	environmentType: BillingEnvironmentType;
};

export type BillingViewModel = {
	customerInfo: CustomerInfoModel;
};

export function load(signal?: AbortSignal): Promise<BillingViewModel> {
	return httpClient.get<BillingViewModel>("UiApi/Billing", {}, {signal});
}

export function saveCustomerInfo(model: CustomerInfoSaveModel, signal?: AbortSignal): Promise<void> {
	return httpClient.post<void>("UiApi/Billing/CustomerInfo", model, {signal});
}